import document from 'document';
import { cookie } from '../../utilities/cookie';

export const usageType = () => 
{
    const cookieInfo = {
        name: 'usageType',
        bch: 'BCH',
        pch: 'PCH'
    }

    const contractType = 'contract_type';

    const refreshState = {
        standard: 'standard',
        search: 'search'
    }

    const refreshAttributeName= 'data-refresh';

    const searchScreenUrl= 'search-personal-leasing';

    const selectors = {
        personalBusinessToggle: 'PersonalBusinessToggle',
        personalBusinessToggleContainer: 'PersonalBusinessToggleContainer',
    };

    function setDataLayer(isChecked) {
        const productType = isChecked ? "Business" : "Personal";
        window.dataLayer.push(
        {
            'event' : 'product_toggle',
            'category' : 'Product Type',
            'action' : 'toggle',
            'label' : productType
        });
    }

    function removeQueryParam(url, keyToRemove) {
        const urlParts = url.split('?');
        if (urlParts.length < 2) {
          // If there are no query parameters, return the original URL.
            return url;
        }

        const baseURL = urlParts[0];
        const queryParams = urlParts[1].split('&');
        const updatedParams = [];

        for (const param of queryParams) {
            const [key] = param.split('=');
            if (key !== keyToRemove) {
                updatedParams.push(param);
            }
        }

        if (updatedParams.length === 0) {
            return baseURL;
        }

        return baseURL + '?' + updatedParams.join('&');
    }


    const handlePersonalBusinessToggleClick = event => {
        if (event) {
            cookie.createCookie(cookieInfo.name, event.target.checked ? cookieInfo.bch:cookieInfo.pch);
            if (!event.target.checked) {
                    let params = new URLSearchParams(window.location.search);
                    if (history.replaceState && params.has(contractType)) {
                        let searchString = removeQueryParam(window.location.search, contractType);
                        let newUrl = window.location.protocol + '//' + window.location.host + window.location.pathname +  searchString + window.location.hash;
                        history.replaceState(null, '', newUrl);
                }
            }
            const toggleContainer = document.getElementById(selectors.personalBusinessToggleContainer);
            setDataLayer(event.target.checked);
            if (toggleContainer) {
                const dataType = toggleContainer.getAttribute(refreshAttributeName);
                if (dataType && dataType === refreshState.standard && !event.isStopReload) {
                    window.location.reload();
                }
            }
        }
    }

    const init = () => {
        const toggle = document.getElementById(selectors.personalBusinessToggle);
        if(toggle){
            toggle.addEventListener('change', event => handlePersonalBusinessToggleClick(event));
            const toggleContainer = document.getElementById(selectors.personalBusinessToggleContainer);
            var currentLocation = window.location;
            if (currentLocation.href.indexOf(searchScreenUrl) > -1) {
                toggleContainer.setAttribute(refreshAttributeName,refreshState.search);
            } else {
                toggleContainer.setAttribute(refreshAttributeName,refreshState.standard);
            }
            const cookieValue = cookie.readCookie(cookieInfo.name);

            if (cookieValue && cookieValue.length > 0) {
                cookieValue == cookieInfo.bch ? toggle.checked = true : toggle.checked = false;
            }

            let params = new URLSearchParams(window.location.search);
            if(params.has(contractType) && params.get(contractType).toLowerCase() === cookieInfo.bch.toLowerCase()) {
                toggle.checked = true;
                var event = new Event('change');
                //  set not reload needed
                event.isStopReload = true;
                // Dispatch the event manually.
                toggle.dispatchEvent(event);
            }
        }
    };
    return {
        init
    };
};